import API from "./index"

class ItensConsumidosService {
  constructor() {
    this.path = `api/tarefaspedido`
  }

  getSomaValorTotalItensPedidosRetirada({ ...params }) {
    return API.get(`${this.path}/getSomaValorTotalItensPedidosRetirada`, { params });
  }

  getSomaItensPedidosRetirada({ ...params }) {
    return API.get(`${this.path}/getSomaItensPedidosRetirada`, { params });
  }

}

export default ItensConsumidosService
